/** Shared badge styles for semantic status and category labels. */
import { ReactNode, RefObject } from "react";
import { cva, cx, RecipeVariantProps } from "styled-system/css";

export type TagVariant = NonNullable<RecipeVariantProps<typeof tagStyles>>["variant"];

export interface TagProps {
  children: ReactNode;
  variant?: TagVariant;
  ref?: RefObject<HTMLDivElement>;
  className?: string;
}

export function Tag({ children, variant, ref, className }: TagProps) {
  return (
    <div ref={ref} className={cx(tagStyles({ variant }), className)}>
      {children}
    </div>
  );
}

const tagStyles = cva({
  base: {
    px: "4",
    py: "2",
    textStyle: "highlight.md",
    rounded: "primary",
    transitionPreset: "colors",
  },
  variants: {
    variant: {
      primary: {
        bg: "tag.background.primary",
        color: "tag.text.primary",
      },
      secondary: {
        bg: "tag.background.secondary",
        color: "tag.text.secondary",
      },
      neutral: {
        bg: "tag.background.neutral",
        color: "tag.text.neutral",
      },
      gold: {
        bg: "tag.background.gold",
        color: "tag.text.gold",
      },
      positive: {
        bg: "tag.background.positive",
        color: "tag.text.positive",
      },
      negative: {
        bg: "tag.background.negative",
        color: "tag.text.negative",
      },
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});
